import {Alert, Button, IconButton, Snackbar} from "@mui/material";
import {X} from "lucide-react";
import type {ReactElement} from "react";
import {useNewReleaseAvailable} from "@/hooks/useNewReleaseAvailable.ts";

const NewReleasePrompt = (): ReactElement => {
    const {available, dismiss} = useNewReleaseAvailable();

    return (
        <Snackbar
            open={available}
            anchorOrigin={{vertical: "bottom", horizontal: "center"}}
            onClose={(_event, reason) => {
                if (reason !== "clickaway") {
                    dismiss();
                }
            }}
        >
            <Alert
                severity="info"
                variant="filled"
                action={
                    <>
                        <Button
                            color="inherit"
                            size="small"
                            onClick={() => window.location.reload()}
                        >
                            Reload
                        </Button>
                        <IconButton
                            aria-label="Dismiss"
                            color="inherit"
                            size="small"
                            onClick={dismiss}
                        >
                            <X size={18} />
                        </IconButton>
                    </>
                }
            >
                A new version is available.
            </Alert>
        </Snackbar>
    );
};

export default NewReleasePrompt;
